import { useMediaQuery } from '@uidotdev/usehooks';

export function useIsSmall() {
  return useMediaQuery('only screen and (width < 64rem)');
}
